import { render, staticRenderFns } from "./ProductRegistrationProgressBar.vue?vue&type=template&id=498d0d8b&"
import script from "./ProductRegistrationProgressBar.vue?vue&type=script&lang=js&"
export * from "./ProductRegistrationProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports